import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { Lotus, LotusRule, Temple } from "../Ornaments";

/* Book group and temple pavilion are raster artwork from the approved section design. */
export function GuruvaniOrg() {
  return (
    <section className="guru-org" aria-label="Guruvani and our organization">
      <div className="go-art go-art--books" aria-hidden="true">
        <img
          src="/images/home/guruvani-books.webp"
          alt=""
          loading="lazy"
          width={535}
          height={357}
        />
      </div>

      <div className="go-block go-block--guruvani">
        <div className="go-head">
          <BookOpen className="go-icon" aria-hidden="true" strokeWidth={1.3} />
          <h2 className="go-title">Guruvani</h2>
        </div>
        <LotusRule className="go-rule" />
        <p className="go-text">
          Explore the profound discourses, written works, letters, and spiritual
          guidance from Gurudev.
        </p>
        <Link to="/guruvani" className="btn btn-primary go-btn">
          Explore Guruvani
          <ArrowRight aria-hidden="true" />
        </Link>
      </div>

      <div className="go-divider" aria-hidden="true">
        <Lotus className="go-divider-lotus" />
      </div>

      <div className="go-block go-block--org">
        <div className="go-head">
          <Temple className="go-icon go-icon--temple" />
          <h2 className="go-title">Our Organization</h2>
        </div>
        <LotusRule className="go-rule" />
        <p className="go-text">
          Founded by Srimati Shantaben Shantilal Bhudarmal Adani Family and run
          by{" "}
          <span className="nowrap">Sri Siddhi-Bhuvan-Manohar Jain Trust.</span>
        </p>
        <Link to="/about" className="btn btn-outline go-btn">
          Learn More
          <ArrowRight aria-hidden="true" />
        </Link>
      </div>

      <div className="go-art go-art--pavilion" aria-hidden="true">
        <img
          src="/images/home/org-pavilion.webp"
          alt=""
          loading="lazy"
          width={329}
          height={357}
        />
      </div>
    </section>
  );
}
